import keyMirror from 'keymirror'
import _mapValues from 'lodash/mapValues'
import _uniqueId from 'lodash/uniqueId'

export const TagType = keyMirror({
  ANY: null,
  CONVERSATION: null,
})

export const TagStatus = keyMirror({
  ENABLED: null,
  ARCHIVED: null,
})

export const constants = _mapValues(keyMirror({
  FETCH_TAG_LIST_PENDING: null,
  FETCH_TAG_LIST_FAILED: null,
  RECEIVE_TAG_LIST: null,

  CREATE_TAG_PENDING: null,
  CREATE_TAG_FAILED: null,

  UPDATE_TAG_PENDING: null,
  UPDATE_TAG_FAILED: null,
  RECEIVE_TAG: null,

  DELETE_TAG_PENDING: null,
  DELETE_TAG_FAILED: null,
  DELETE_TAG_SUCCESS: null,

  TAG_CONVERSATION_PENDING: null,
  TAG_CONVERSATION_FAILED: null,
  TAG_CONVERSATION_SUCCESS: null,

  UNTAG_CONVERSATION_PENDING: null,
  UNTAG_CONVERSATION_FAILED: null,
  UNTAG_CONVERSATION_SUCCESS: null,

  TAG_COMPANY_PENDING: null,
  TAG_COMPANY_FAILED: null,
  TAG_COMPANY_SUCCESS: null,

  UNTAG_COMPANY_PENDING: null,
  UNTAG_COMPANY_FAILED: null,
  UNTAG_COMPANY_SUCCESS: null,

  TAG_END_USER_PENDING: null,
  TAG_END_USER_FAILED: null,
  TAG_END_USER_SUCCESS: null,

  UNTAG_END_USER_PENDING: null,
  UNTAG_END_USER_FAILED: null,
  UNTAG_END_USER_SUCCESS: null,

  SET_RESPONSE_TAGS_PENDING: null,
  SET_RESPONSE_TAGS_FAILED: null,
  SET_RESPONSE_TAGS_SUCCESS: null,
}), _uniqueId)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tags/constants.js